import { CustomerTenant } from './models';

export type Perm = string;

export function hasPerm(tenant: CustomerTenant | null | undefined, perm: Perm): boolean {
  if (!tenant) return false;
  return tenant.permissions.includes(perm);
}

export function hasAnyPerm(tenant: CustomerTenant | null | undefined, perms: Perm[]): boolean {
  return perms.some((p) => hasPerm(tenant, p));
}

// Common permission constants used across the app.
export const PERMS = {
  tenant_view: 'tenancy.view_tenant',
  member_view: 'tenancy.view_tenantmember',
  member_change: 'tenancy.change_tenantmember',
  group_view: 'tenancy.view_tenantgroup',
  group_change: 'tenancy.change_tenantgroup',
  permission_view: 'tenancy.view_tenantpermission',
  permission_change: 'tenancy.change_tenantpermission',
  merch_view_catalog: 'merch.view_catalog',
  merch_manage_catalog: 'merch.manage_catalog',
  merch_manage_evaluations: 'merch.manage_evaluations',
  merch_manage_connections: 'merch.manage_provider_connections',
  merch_manage_probes: 'merch.manage_provider_probes',
} as const;
